/**
 * Serialize a DataGrid sort / filter model into the query-string contract both
 * concepts endpoints parse (``sort=field:dir`` and ``filter=field:op(value)``).
 *
 * Single-column only by design: the created-group repository splits ``sort`` on
 * a single ``:`` and would drop a multi-column ``a:asc,b:desc`` entirely, so the
 * grid is held to one sort + one filter at a time (mirroring the details dialog)
 * and these helpers emit just the first active entry.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */

import type { GridFilterModel, GridSortModel } from '@mui/x-data-grid-pro';

/** ``[{ field: 'conceptName', sort: 'asc' }]`` → ``conceptName:asc`` (or ``''``). */
export const serializeConceptsSort = (sortModel: GridSortModel): string => {
  const first = sortModel[0];
  return first?.field ? `${first.field}:${first.sort ?? 'asc'}` : '';
};

/** ``[{ field, operator, value }]`` → ``conceptName:contains(foo)`` (or ``''``). */
export const serializeConceptsFilter = (filterModel: GridFilterModel): string => {
  const item = (filterModel.items ?? []).find(
    (it) =>
      it.field && it.operator && it.value !== undefined && it.value !== null && it.value !== ''
  );
  return item ? `${item.field}:${item.operator}(${item.value})` : '';
};
